import { registerPlugin } from '@capacitor/core';
const LaoOneSDK = registerPlugin('LaoOneSDK', {
    web: () => import('./web').then((m) => new m.MiniappSDKWeb()),
});
export * from './definitions';
export { LaoOneSDK };
//# sourceMappingURL=index.js.map